module.exports = __webpack_public_path__ + "static/media/4.de95c9e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shoes/4.png
// module id = 1072
// module chunks = 0